import React from "react";

const CommandRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.99995 4.99995V3.59995C4.99995 2.82675 4.37315 2.19995 3.59995 2.19995C2.82675 2.19995 2.19995 2.82675 2.19995 3.59995C2.19995 4.37315 2.82675 4.99995 3.59995 4.99995H4.99995ZM4.99995 4.99995H11M4.99995 4.99995V11M11 4.99995H12.4C13.1732 4.99995 13.8 4.37315 13.8 3.59995C13.8 2.82675 13.1732 2.19995 12.4 2.19995C11.6268 2.19995 11 2.82675 11 3.59995V4.99995ZM11 4.99995V11M11 11H12.4C13.1732 11 13.8 11.6268 13.8 12.4C13.8 13.1732 13.1732 13.8 12.4 13.8C11.6268 13.8 11 13.1732 11 12.4V11ZM11 11H4.99995M4.99995 11H3.59995C2.82675 11 2.19995 11.6268 2.19995 12.4C2.19995 13.1732 2.82675 13.8 3.59995 13.8C4.37315 13.8 4.99995 13.1732 4.99995 12.4V11Z",
  stroke: "currentColor",
  strokeOpacity: 0.5,
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(CommandRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;